/* app/js/src/components/live/live.component.scss */
.cursor-pointer {
  cursor: pointer;
}
@keyframes gradientFill {
  from {
    transform: scaleX(0);
  }
  to {
    transform: scaleX(1);
  }
}
:host {
  font-size: 1.375rem;
  width: 100%;
  background-color: rgb(238, 242, 246);
  -webkit-user-select: none;
  user-select: none;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.live-container {
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: start;
  width: 90%;
  max-width: 1800px;
  height: 100%;
  margin: 0 auto;
  padding: clamp(0.5rem, 1.5vw, 1.5rem);
  box-sizing: border-box;
  overflow: hidden;
}
@media (min-width: 1600px) {
  .live-container .title {
    font-size: 1.875rem;
  }
}
.live-container .title {
  font-weight: 600;
  color: #232f3a;
  margin-bottom: clamp(5px, 1vh, 10px);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  flex-shrink: 0;
}
.live-container .main {
  display: inline-grid;
  grid-template-columns: 1fr 1fr;
  gap: clamp(0.75rem, 1.5vw, 1.5rem);
  flex: 1;
  min-height: 0;
  overflow: hidden;
}
.live-container .main .working-space {
  width: 100%;
  height: 100%;
  display: flex;
  margin: 0 auto;
  flex-direction: column;
  gap: clamp(0.4rem, 0.8vh, 0.8rem);
  min-height: 0;
}
.live-container .main .working-space .players-wrapper {
  width: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  min-height: 40%;
  aspect-ratio: auto;
}
.live-container .main .working-space .players-wrapper.video-loaded {
  aspect-ratio: 16/9;
}
.live-container .main .working-space .players-wrapper.video-loaded .webrtc-preview.video {
  aspect-ratio: 16/9;
  height: auto;
  object-fit: contain;
  background-color: #000;
}
.live-container .main .working-space .players-wrapper .player-title {
  color: white;
  height: clamp(2rem, 3vh, 2.5rem);
  display: flex;
  align-items: center;
  justify-content: start;
  padding-left: 0.8rem;
  font-size: clamp(0.75rem, 1vw, 0.875rem);
  font-weight: 600;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  border-radius: 5px 5px 0 0;
  flex-shrink: 0;
}
.live-container .main .working-space .players-wrapper .player-title.program {
  background-color: #ef4444;
}
.live-container .main .working-space .players-wrapper .player-title.preview {
  background-color: rgb(85, 146, 142);
}
.live-container .main .working-space .players-wrapper .webrtc-preview {
  width: 100%;
  height: 100%;
  object-fit: fill;
  flex: 1;
  min-height: 0;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
}
.live-container .main .working-space .players-wrapper .webrtc-preview.no-input-data {
  color: white;
  text-align: center;
  vertical-align: middle;
  display: flex;
  background-color: black;
  align-items: center;
  justify-content: center;
}
.live-container .main .working-space .info-card {
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  max-width: 100%;
  min-height: 0;
  padding: 1.7rem;
  border-radius: 0.3rem;
  border: 1px solid rgba(0, 0, 0, 0.08);
  background-color: #ffffff;
  overflow: hidden;
}
.live-container .main .working-space .info-card .info-card-inline {
  display: inline-block;
}
.live-container .main .working-space .info-card .info-card-inline > * {
  display: inline-block;
  margin-right: clamp(0.2rem, 0.3vh, 0.3rem);
}
.live-container .main .working-space .info-card .info-card-title {
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 400;
  text-transform: uppercase;
  color: #232f3a;
  margin-bottom: clamp(0.2rem, 0.3vh, 0.3rem);
  flex-shrink: 0;
}
.live-container .main .working-space .info-card .info-card-content {
  font-size: 1.35rem;
  line-height: 1.65rem;
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: 0.5px;
  color: #232f3a;
  margin-bottom: clamp(0.2rem, 0.3vh, 0.3rem);
  -webkit-user-select: text;
  user-select: text;
  flex-shrink: 0;
}
.live-container .main .working-space .info-card .info-card-content-fields {
  display: flex;
  flex-direction: column;
  gap: clamp(0.2rem, 0.3vh, 0.3rem);
  margin-bottom: clamp(0.5rem, 1vh, 1rem);
  min-height: 8rem;
}
.live-container .main .working-space .info-card .info-card-content-fields table {
  width: 100%;
  border-collapse: collapse;
}
.live-container .main .working-space .info-card .info-card-content-fields table tr {
  display: flex;
  align-items: center;
  justify-content: start;
  gap: clamp(0.2rem, 0.4vw, 0.4rem);
}
.live-container .main .working-space .info-card .info-card-content-fields table tr .details-key {
  flex: 0 0 65%;
  color: #232f3a;
}
.live-container .main .working-space .info-card .info-card-content-fields table tr .details-value {
  flex: 0 0 35%;
  display: flex;
  align-items: center;
  justify-content: end;
  padding-right: clamp(0.2rem, 0.4vw, 0.4rem);
}
.live-container .main .working-space .info-card .info-card-content-fields table tr > * {
  font-weight: 400;
  font-size: 1.125rem;
}
.live-container .main .working-space .info-card .info-card-content-fields table tr > *.bold {
  font-weight: 700;
  font-size: 1.5rem;
}
.live-container .main .working-space .info-card .buttons-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: clamp(0.5rem, 0.8vh, 0.8rem);
  padding-bottom: clamp(1rem, 2vh, 2rem);
  flex: 1;
  min-height: 0;
}
.live-container .main .working-space .info-card .buttons-wrapper .button {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: clamp(8px, 1.2vh, 12px) clamp(16px, 2.5vw, 24px);
  text-transform: uppercase;
  user-select: none;
  -webkit-user-select: none;
  -webkit-tap-highlight-color: transparent;
  -webkit-touch-callout: none;
  touch-action: manipulation;
  border-radius: 5px;
  font-weight: 700;
  font-size: 1.125rem;
  transition: all 0.2s ease;
  color: #ffffff;
  background-color: rgb(45, 187, 252);
  border: 1px solid rgb(45, 187, 252);
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 15%;
  justify-content: center;
  flex-shrink: 0;
  -webkit-user-drag: none;
  -moz-user-select: none;
  -ms-user-select: none;
}
.live-container .main .working-space .info-card .buttons-wrapper .button span {
  margin: auto;
  position: relative;
  z-index: 1;
}
.live-container .main .working-space .info-card .buttons-wrapper .button.red {
  background-color: transparent;
  border-color: rgb(239, 93, 93);
  flex: 0.35;
  color: rgb(239, 93, 93);
  line-height: 4px;
  padding: clamp(4px, 0.5vh, 0.5rem);
  font-size: 1rem;
}
.live-container .main .working-space .info-card .buttons-wrapper .button.red:hover {
  color: white;
  border-color: rgb(239, 93, 93);
  background-color: rgb(239, 93, 93);
}
.live-container .main .working-space .info-card .buttons-wrapper .button.red:active:not(.during-skip) {
  font-size: 0.95rem;
  animation: 0.2s ease-in-out font-size 0.2s ease-in-out;
}
.live-container .main .working-space .info-card .buttons-wrapper .button.red.gradient-fill::before {
  background:
    linear-gradient(
      90deg,
      rgb(239, 93, 93) 0%,
      rgb(239, 93, 93) 100%);
}
.live-container .main .working-space .info-card .buttons-wrapper .button.regular {
  flex: 0.35;
}
.live-container .main .working-space .info-card .buttons-wrapper .button.regular.gradient-fill::before {
  background:
    linear-gradient(
      90deg,
      rgb(45, 187, 252) 0%,
      rgb(45, 187, 252) 100%);
}
.live-container .main .working-space .info-card .buttons-wrapper .button:hover {
  opacity: 0.9;
}
.live-container .main .working-space .info-card .buttons-wrapper .button.during-skip {
  opacity: 0.8 !important;
  background-color: lightgray !important;
  color: #232f3a !important;
  border-color: lightgray !important;
  cursor: not-allowed !important;
}
.live-container .main .working-space .info-card .buttons-wrapper .button.during-skip svg {
  opacity: 0;
}
.live-container .main .working-space .info-card .buttons-wrapper .button.during-skip:active {
  transform: scale(1) !important;
}
.live-container .main .working-space .info-card .buttons-wrapper .button.gradient-fill::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transform: scaleX(0);
  transform-origin: left;
  z-index: 0;
}
.live-container .main .working-space .info-card .buttons-wrapper .button.gradient-fill.filling {
  color: #ffffff;
}
.live-container .main .working-space .info-card .buttons-wrapper .button.gradient-fill.filling::before {
  animation: gradientFill var(--fill-duration) linear forwards;
}
@media (min-width: 2300px) and (min-height: 1000px) {
  .live-container {
    padding: 2rem;
  }
  .live-container .title {
    font-size: 2.25rem;
    margin-bottom: 1rem;
  }
  .live-container .main {
    gap: 2rem;
  }
  .live-container .main .working-space {
    gap: 1rem;
  }
  .live-container .main .working-space .players-wrapper .player-title {
    height: 3rem;
    font-size: 1.125rem;
    padding-left: 1.2rem;
  }
  .live-container .main .working-space .info-card .info-card-inline > * {
    margin-right: 0.5rem;
  }
  .live-container .main .working-space .info-card .info-card-title {
    font-size: 1.125rem;
    line-height: 1.5rem;
    margin-bottom: 0.5rem;
  }
  .live-container .main .working-space .info-card .info-card-content {
    font-size: 1.75rem;
    line-height: 2rem;
    margin-bottom: 0.5rem;
  }
  .live-container .main .working-space .info-card .info-card-content-fields {
    gap: 0.5rem;
    margin-bottom: 1.5rem;
  }
  .live-container .main .working-space .info-card .info-card-content-fields table tr {
    gap: 0.6rem;
  }
  .live-container .main .working-space .info-card .info-card-content-fields table tr .details-key {
    font-size: 1.375rem;
  }
  .live-container .main .working-space .info-card .info-card-content-fields table tr .details-value {
    padding-right: 0.6rem;
  }
  .live-container .main .working-space .info-card .info-card-content-fields table tr > * {
    font-size: 1.375rem;
  }
  .live-container .main .working-space .info-card .info-card-content-fields table tr > *.bold {
    font-size: 1.875rem;
  }
  .live-container .main .working-space .info-card .buttons-wrapper {
    gap: 1rem;
    padding-bottom: 2.5rem;
  }
  .live-container .main .working-space .info-card .buttons-wrapper .button {
    padding: 16px 32px;
    font-size: 1.375rem;
  }
  .live-container .main .working-space .info-card .buttons-wrapper .button.red {
    padding: 0.75rem;
    font-size: 1.25rem;
  }
}
/*# sourceMappingURL=live.component.css.map */
